import { IComponentOptions } from "angular";
import { EmptyStateService } from "../empty-state.service";
import { IInfoBox } from "../models";

interface IEmptyStateInfoBoxesBindings {
  infoBoxesId?: string;
  marginTop?: number;
  onOpenVideoDialog?(options: { videoUrl: string }): unknown;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface EmptyStateInfoBoxesComponentCtrl extends IEmptyStateInfoBoxesBindings {}
export class EmptyStateInfoBoxesComponentCtrl {
  infoBoxes: IInfoBox[];

  static $inject = ["EmptyStateService"];

  constructor(private emptyStateService: EmptyStateService) {}

  $onInit(): void {
    this.marginTop = this.marginTop || 0;
    this.infoBoxes = this.emptyStateService.getEmptyStateInfoBoxes(this.infoBoxesId);
  }
}

export const EmptyStateInfoBoxesComponent: IComponentOptions = {
  templateUrl: require("./empty-state-info-boxes.jade"),
  controller: EmptyStateInfoBoxesComponentCtrl,
  bindings: {
    infoBoxesId: "@",
    marginTop: "<",
    onOpenVideoDialog: "&",
  },
};
